const UI_SET_BRAND = 'UI_SET_BRAND';
const UI_OPEN_TXTFLD = 'UI_OPEN_TXTFLD';
const UI_CURRENT_FUNCTIONALITY = 'UI_CURRENT_FUNCTIONALITY';

export {
    UI_SET_BRAND,
    UI_OPEN_TXTFLD,
    UI_CURRENT_FUNCTIONALITY,
}
